// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1q0Nx","buttons":"PendingPaymentAlert_buttons__2jC5L"};